
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkMailSignatureSourceEnum } from '../models/work-mail-signature-source-enum';

export function getUpdateMailSettingsDtoFormGroup() {
return new FormGroup({
    signatureSource: new FormControl<WorkMailSignatureSourceEnum | undefined>(undefined, [Validators.required]),
})
;
}
      